<template>
  <div class="wg-seo-tools">
    <list-tools :is-white-glove-variant="true" />
  </div>
</template>

<script>
import ListTools from '@/components/SitesSingleView/Tools/ListTools.vue'

export default {
  name: 'SeoToolsWhiteGlove',
  components: {
    ListTools,
  },
}
</script>
